module.exports = __webpack_public_path__ + "static/media/icon-anger.73abbcc6.svg";